import { SUBMOTIVE2_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useSubmotive2ListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${SUBMOTIVE2_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
